module.exports = __webpack_public_path__ + "static/media/Dragnet Alpha Animated.ba4d2013.svg";